(function() {
    'use strict';

    angular
        .module('app')
        .controller('bulletinMoreController', bulletinMoreController);

    function bulletinMoreController(viewModel) {
        var vm = this;

        onInit();

        function onInit() {
            vm.data = viewModel.data;
        }
    }
})();
